/*
 * This is simple wrapper for this code:
 * https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
 * This class has documentation so please keep it up to date.
 */

export default class CustomInfobox {
    constructor(point, content, gmMap) {
        this.Popup = null;
        this.gmMap = gmMap;
        this.point = point;
        this.content = content;
        // nesting: popup-tip-anchor < popup-bubble-anchor < popup-bubble-content
        this.anchorCssClass = "popup-tip-anchor";
        this.bubbleCssClass = "popup-bubble-anchor";
        this.contentCssClass = "popup-bubble-content";

        this.initialize();
    }

    /**
     * @private
     */
    initialize() {
        this.definePopupClass();
        const popup = new this.Popup(this.point, this.content);
        popup.setMap(this.gmMap);
    }

    /**
     * Defines the Popup class.
     * @private
     */
    definePopupClass() {
        /**
         * A customized popup on the map.
         * @param {!google.maps.LatLng} position
         * @param {!Element} content
         * @constructor
         * @extends {google.maps.OverlayView}
         */

        const classScope = this;

        this.Popup = function createPopup(position, content) {
            this.position = position;

            content.classList.add(classScope.contentCssClass);

            const pixelOffset = document.createElement("div");
            pixelOffset.classList.add(classScope.bubbleCssClass);
            pixelOffset.appendChild(content);

            this.anchor = document.createElement("div");
            this.anchor.classList.add(classScope.anchorCssClass);
            this.anchor.appendChild(pixelOffset);

            // Optionally stop clicks, etc., from bubbling up to the map.
            this.stopEventPropagation();
        };
        // NOTE: google.maps.OverlayView is only defined once the Maps API has
        // loaded. That is why Popup is defined inside initMap().
        this.Popup.prototype = Object.create(window.google.maps.OverlayView.prototype);

        /** Called when the popup is added to the map. */
        this.Popup.prototype.onAdd = function appendAnchor() {
            this.getPanes().floatPane.appendChild(this.anchor);
        };

        /** Called when the popup is removed from the map. */
        this.Popup.prototype.onRemove = function removeAnchor() {
            if (this.anchor.parentElement) {
                this.anchor.parentElement.removeChild(this.anchor);
            }
        };

        /** Called when the popup needs to draw itself. */
        this.Popup.prototype.draw = function drawPopup() {
            const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
            // Hide the popup when it is far out of view.
            const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                ? "block"
                : "none";

            if (display === "block") {
                this.anchor.style.left = `${divPosition.x}px`;
                this.anchor.style.top = `${divPosition.y}px`;
            }
            if (this.anchor.style.display !== display) {
                this.anchor.style.display = display;
            }
        };

        /** Stops clicks/drags from bubbling up to the map. */
        this.Popup.prototype.stopEventPropagation = function stopPropogation() {
            this.anchor.style.cursor = "auto";

            ["click", "dblclick", "contextmenu", "wheel", "mousedown", "touchstart",
                "pointerdown"]
                .forEach((event) => {
                    this.anchor.addEventListener(event, (e) => {
                        e.stopPropagation();
                    });
                });
        };
    }
}
